import { Component } from "react";
import Sidebar from "../../Components/Layout/Sidebar/Sidebar";
import { appContext } from "../../AppContext";
import "../../styles/css/table.scss";
import "../../App.css";

class NoRights extends Component
{
  private labels = appContext().labels;

  public render(): JSX.Element
  {
    return (
      <div className="page-container" style={{ overflow: "hidden", display: "flex", backgroundColor: "var(--ui-background)" }}>
        <Sidebar {...this.props} />
        <div className="rightPanel">
          <div className="rightPanel-main-content">
            <div className="redirectContainer">
              <div className="title titleCenter">{this.labels.HubLabelNoRights}</div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}


export default NoRights;
